import "./ExperienceDetail.scss";

const VertuMotorsWebDev = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">
            October 2021 - August 2023
          </span>
          <h1 className="experience-detail__title">
            Web Developer at Vertu Motors
          </h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              Worked as a Web Developer at Vertu Motors on Angular and React
              apps that built the 14 websites under the Vertu Motors brand as
              well as bespoke apps powering their internal processes.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Responsibilities</h2>
            <ul>
              <li>
                Developing and maintaining 14 websites under the Vertu Motors
                brand
              </li>
              <li>
                Building bespoke internal applications to streamline business
                processes
              </li>
              <li>Working with both React and Angular frameworks</li>
              <li>Collaborating with designers and backend developers</li>
              <li>
                Ensuring consistent brand experience across multiple sites
              </li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">React</span>
              <span className="experience-detail__tag">Angular</span>
              <span className="experience-detail__tag">TypeScript</span>
              <span className="experience-detail__tag">JavaScript</span>
              <span className="experience-detail__tag">SCSS</span>
            </div>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">
          ← Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default VertuMotorsWebDev;
